var map = {
	"./gopay.png": "./src/assets/payment_methods/gopay.png",
	"./payment_icon_banktransfer.png": "./src/assets/payment_methods/payment_icon_banktransfer.png",
	"./payment_icon_csobgtw.png": "./src/assets/payment_methods/payment_icon_csobgtw.png",
	"./payment_icon_gopay.png": "./src/assets/payment_methods/payment_icon_gopay.png",
	"./payment_icon_gpwebpay.png": "./src/assets/payment_methods/payment_icon_gpwebpay.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/payment_methods sync recursive ^\\.\\/.*$";